(function(){
  var C=window.LUNO||{};
  function $(s,c){return (c||document).querySelector(s)}
  function $all(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))}
  function money(cents){return '£'+(cents/100).toFixed(2)}

  /* ---------- smooth scroll (Lenis) ---------- */
  function initLenis(){
    if(typeof Lenis==='undefined'){return}
    var lenis=new Lenis({lerp:.09,wheelMultiplier:1});
    function raf(t){lenis.raf(t);requestAnimationFrame(raf)}
    requestAnimationFrame(raf);
    if(window.gsap&&window.ScrollTrigger){lenis.on('scroll',ScrollTrigger.update)}
    $all('a[href^="#"]').forEach(function(a){a.addEventListener('click',function(e){var id=a.getAttribute('href');if(id.length>1){var el=$(id);if(el){e.preventDefault();lenis.scrollTo(el,{offset:-80})}}})});
  }

  /* ---------- reveals + hero + parallax ---------- */
  function initMotion(){
    if(window.gsap&&window.ScrollTrigger){
      gsap.registerPlugin(ScrollTrigger);
      /* hero masked lines */
      var lines=$all('.hero .line span');
      if(lines.length){gsap.to(lines,{y:'0%',duration:1.2,ease:'expo.out',stagger:.12,delay:.15});
        gsap.to('.hero p.sub',{opacity:1,y:0,duration:1,delay:.7,ease:'power2.out'});
        gsap.to('.hero .cta-row',{opacity:1,y:0,duration:1,delay:.9,ease:'power2.out'});}
      /* hero parallax */
      var hb=$('.hero-bg img');
      if(hb){gsap.to(hb,{yPercent:14,ease:'none',scrollTrigger:{trigger:'.hero',start:'top top',end:'bottom top',scrub:true}})}
      /* editorial marquee scroll speed */
      $all('.emarq-track').forEach(function(t){gsap.to(t,{xPercent:-35,ease:'none',scrollTrigger:{trigger:t,start:'top bottom',end:'bottom top',scrub:1}})});
    }
    /* IntersectionObserver reveals (works with or without gsap) */
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}})},{threshold:.14});
    $all('.reveal,.stagger,.sec-head,.chapter').forEach(function(el){io.observe(el)});
  }

  /* ---------- mobile menu ---------- */
  function initMenu(){
    var m=$('.m-menu');if(!m)return;
    $('.burger').addEventListener('click',function(){m.classList.add('open');document.body.classList.add('no-scroll')});
    $all('[data-close-menu]',m).forEach(function(b){b.addEventListener('click',function(){m.classList.remove('open');document.body.classList.remove('no-scroll')})});
    $all('.m-menu nav a').forEach(function(a){a.addEventListener('click',function(){m.classList.remove('open');document.body.classList.remove('no-scroll')})});
  }

  /* ---------- cart drawer ---------- */
  var drawer,overlay;
  function openCart(){drawer.classList.add('open');overlay.classList.add('open');document.body.classList.add('no-scroll')}
  function closeCart(){drawer.classList.remove('open');overlay.classList.remove('open');document.body.classList.remove('no-scroll')}
  function renderCart(cart){
    var count=cart.item_count;
    $all('[data-cart-count]').forEach(function(el){el.textContent=count;el.style.display=count>0?'flex':'none'});
    var items=$('[data-cart-items]');
    if(!items)return;
    if(count===0){items.innerHTML='<div class="cd-empty"><p>Your bag is empty.</p><p style="font-size:13px;margin-top:8px">Time to kit out your next adventure.</p></div>';}
    else{
      items.innerHTML=cart.items.map(function(it){
        var v=(it.variant_title&&it.variant_title!=='Default Title')?'<div class="var">'+it.variant_title+'</div>':'';
        return '<div class="cd-item" data-key="'+it.key+'">'+
          '<img src="'+(it.image?it.image.replace(/(\.[^.\/]+)(\?.*)?$/,'_120x$1'):'')+'" alt="'+it.product_title+'">'+
          '<div><h4>'+it.product_title+'</h4>'+v+
          '<div class="qty" data-testid="cart-qty"><button data-dec>&minus;</button><input value="'+it.quantity+'" readonly><button data-inc>+</button></div>'+
          '<button class="cd-remove" data-remove data-testid="cart-remove">Remove</button></div>'+
          '<div class="lp">'+money(it.final_line_price)+'</div></div>';
      }).join('');
    }
    var sub=$('[data-cart-subtotal]');if(sub)sub.textContent=money(cart.total_price);
    /* free shipping bar */
    var bar=$('[data-ship-msg]'),fill=$('[data-ship-fill]');
    if(bar){var thr=C.freeShip||5000;var rem=thr-cart.total_price;
      if(rem>0){bar.innerHTML='You\'re <b>'+money(rem)+'</b> away from FREE UK shipping.';fill.style.width=Math.min(100,cart.total_price/thr*100)+'%';}
      else{bar.innerHTML='&#10003; You\'ve unlocked FREE UK shipping!';fill.style.width='100%';}
    }
    bindCartItemEvents();
  }
  function fetchCart(){fetch(C.cartUrl+'.js').then(function(r){return r.json()}).then(renderCart)}
  function changeLine(key,qty){fetch(C.changeUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json()}).then(renderCart)}
  function bindCartItemEvents(){
    $all('.cd-item').forEach(function(row){
      var key=row.getAttribute('data-key');var q=parseInt($('input',row).value,10);
      var inc=$('[data-inc]',row),dec=$('[data-dec]',row),rm=$('[data-remove]',row);
      if(inc)inc.onclick=function(){changeLine(key,q+1)};
      if(dec)dec.onclick=function(){changeLine(key,q-1)};
      if(rm)rm.onclick=function(){changeLine(key,0)};
    });
  }
  function initCart(){
    drawer=$('.cart-drawer');overlay=$('[data-overlay]');if(!drawer)return;
    $all('[data-cart-open]').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();openCart()})});
    $all('[data-cart-close]').forEach(function(b){b.addEventListener('click',closeCart)});
    overlay.addEventListener('click',closeCart);
    document.addEventListener('keydown',function(e){if(e.key==='Escape')closeCart()});
    fetchCart();
    /* add to cart forms */
    $all('form.product-form-js').forEach(function(f){
      f.addEventListener('submit',function(e){
        e.preventDefault();
        var btn=$('[data-add]',f);var txt=btn?btn.textContent:'';if(btn){btn.textContent='Adding…';btn.disabled=true}
        fetch(C.addUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:$('[name=id]',f).value,quantity:parseInt(($('[data-qty-input]',f)||{}).value||1,10)})})
        .then(function(r){return r.json()})
        .then(function(){fetchCart();openCart();if(btn){btn.textContent='Added ✓';setTimeout(function(){btn.textContent=txt;btn.disabled=false},1200)}});
      });
    });
  }

  /* ---------- product gallery ---------- */
  function initGallery(){
    var main=$('[data-gallery-main] img');if(!main)return;
    $all('[data-thumb]').forEach(function(t){t.addEventListener('click',function(){
      main.src=t.getAttribute('data-src');
      $all('[data-thumb]').forEach(function(x){x.classList.remove('active')});t.classList.add('active');
    })});
  }

  /* ---------- variant picker + quantity ---------- */
  function initVariants(){
    var form=$('form.product-form-js');if(!form)return;
    var dataEl=$('[data-variants-json]');if(!dataEl)return;
    var variants=JSON.parse(dataEl.textContent);
    var idInput=$('[name=id]',form);
    var selects=$all('[data-opt]',form);
    function update(){
      var chosen=selects.map(function(s){return s.value});
      var v=variants.find(function(vr){return chosen.every(function(c,i){return vr.options[i]===c})})||variants[0];
      idInput.value=v.id;
      var pe=$('[data-price]');if(pe)pe.textContent=money(v.price);
      var st=$('[data-stock]');var add=$('[data-add]',form);
      if(st){if(v.available){st.className='stock';st.querySelector('span').textContent='In stock — ready to ship';if(add){add.disabled=false;add.textContent='Add to cart'}}
        else{st.className='stock out';st.querySelector('span').textContent='Sold out';if(add){add.disabled=true;add.textContent='Sold out'}}}
    }
    selects.forEach(function(s){s.addEventListener('change',update)});
    update();
    /* qty stepper */
    var qi=$('[data-qty-input]',form);
    if(qi){$('[data-qty-dec]',form).onclick=function(){qi.value=Math.max(1,parseInt(qi.value,10)-1)};$('[data-qty-inc]',form).onclick=function(){qi.value=parseInt(qi.value,10)+1}}
  }

  /* ---------- accordions ---------- */
  function initAcc(){
    $all('.acc button').forEach(function(b){b.addEventListener('click',function(){
      var open=b.getAttribute('aria-expanded')==='true';
      b.setAttribute('aria-expanded',!open);
      var p=b.nextElementSibling;p.style.maxHeight=open?0:p.scrollHeight+40+'px';
    })});
  }

  document.addEventListener('DOMContentLoaded',function(){
    initLenis();initMotion();initMenu();initCart();initGallery();initVariants();initAcc();
  });
})();
